import { NON_PERMISSIBLE_ACCOUNTS_FOR_LOGOUT_MARKETPLACE } from 'const/account/clients'
import getApptimizeStringArray from './getApptimizeStringArray'

/**
 * Determines if ALL accounts are permissible for marketplace redirect on logout.
 * Returns false if the list is empty or any clientId is non-permissible.
 * ROK-5497
 */
const areAllAccountsPermissible = (
  clientIds: (string | undefined)[]
): boolean => {
  if (!clientIds.length) return false
  const nonPermissibleSet: Set<string> = new Set(
    getApptimizeStringArray(
      'nonPermissibleAccountsForLogoutMarketplace',
      NON_PERMISSIBLE_ACCOUNTS_FOR_LOGOUT_MARKETPLACE
    ).map((client: string) => client.toLowerCase())
  )
  return clientIds.every(
    (clientId) => clientId && !nonPermissibleSet.has(clientId.toLowerCase())
  )
}

export default areAllAccountsPermissible
